import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useAnimatedText } from 'src/hooks/use-animate-text';
import { MarkdownComponents } from './markdown-components';

export const StreamingMarkdown = ({
  content,
  duration,
}: {
  content: string;
  duration?: number;
}) => {
  const animatedText = useAnimatedText({ text: content, duration });
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={MarkdownComponents}>
      {animatedText}
    </ReactMarkdown>
  );
};
